import { createSlice } from '@reduxjs/toolkit'
import { UserRole } from 'shared/models/types/User'
import { User } from 'shared/models/user'

interface UserState {
    token: string
    user: User
}

const initialState = {
    token: '',
    user: {
        linkedinUrl: '',
        role: UserRole.candidate,
        id: '',
        firstName: '',
        lastName: '',
        nickname: '',
        email: '',
        phone: '',
        profileImageKey: null,
        isActive: true,
    },
} satisfies UserState as UserState

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload
        },
        setRole: (state, action) => {
            state.user.role = action.payload
        },
        setToken: (state, action) => {
            state.token = action.payload
        },
        removeUser: (state) => {
            state.user = initialState.user
        },
    },
    selectors: {
        selectUser: (state) => state.user,
    },
})

export const { setToken, setUser, removeUser, setRole } = userSlice.actions
export const { selectUser } = userSlice.selectors

export default userSlice.reducer
